export default __webpack_public_path__ + "static/media/aqi-fair.9472df70.svg";